import React from 'react';
import loadable from '@loadable/component';
import Loader from 'src/components/loader';

import productAlertQuery from './query.graphql';

const ProductAlert = loadable(
  () => import(/* webpackChunkName: "product-alert" */ './product-alert'),
  {
    fallback: <Loader />,
  }
);

const ProductAlertPage = () => <ProductAlert />;

ProductAlertPage.graphQL = productAlertQuery;

ProductAlertPage.loadOrder = [{}];

type ProductAlertVariables = {
  id: string;
};

ProductAlertPage.variables = ({ id }: ProductAlertVariables) => ({
  id: parseInt(id, 10),
});

export default ProductAlertPage;
